import type { SolutionId } from '../shared/solutionAnalytics';

/**
 * ### SAFETY_SOLUTION_ID
 *
 * `solution_id` every Listen AI Safety landing-page event carries. Dashboards
 * filter on this literal, so the page reads it from here instead of repeating
 * the string at each reporting site.
 */
export const SAFETY_SOLUTION_ID = 'listen_ai_safety' satisfies SolutionId;
